<template>
    <layout-basic>
        <div class="section">
            <div class="container">
                <div class="columns">
                    <div class="column auto">
                        <form
                                id="app"
                                novalidate
                                action="#"
                                enctype="multipart/form-data"
                                method="post"
                                v-on:submit="formSubmit"
                        >

                            <template>
                                <section>
                                    <div class="level" style="margin-top: 35px">
                                        <div class="level-item is-narrow">
                                            <div>
                                                <h2 class="title">Reorder of {{reorderData.originOrder.reference}}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </template>

                            <template>
                                <section style="margin-top: 55px">
                                    <b-steps
                                            v-model="activeStep"
                                            type="is-info"
                                            :animated="isAnimated"
                                            :has-navigation="hasNavigation"
                                            :icon-prev="prevIcon"
                                            :icon-next="nextIcon">

                                        <b-step-item label="General setup" :clickable="isStepsClickable">
                                            <StepOne/>
                                        </b-step-item>

                                        <b-step-item label="Shipping address" :clickable="isStepsClickable">
                                            <StepTwo/>
                                        </b-step-item>

                                        <b-step-item label="Confirm order" :clickable="isStepsClickable">
                                            <StepFour/>
                                        </b-step-item>

                                        <b-step-item label="Finish" :clickable="isStepsClickable" disabled>
                                            <Success/>
                                        </b-step-item>
                                        <template
                                                slot="navigation"
                                                slot-scope="{previous, next}">
                                            <section style="padding: 1rem;">
                                                <div v-if="reorderData.priceCheckError" class="help is-danger">{{reorderData.priceCheckError}}</div>
                                                <input v-if="activeStep == 2" type="submit" name="submit"
                                                       class="button is-info is-pulled-right"
                                                       value="Reorder">
                                                <b-button
                                                        v-if="activeStep < 2"
                                                        icon-pack="fas"
                                                        class="button is-info is-pulled-right"
                                                        :disabled="next.disabled"
                                                        native-type="submit"
                                                        tag="input"
                                                        value="Next"
                                                >
                                                    Next
                                                </b-button>
                                                <b-button
                                                        v-if="activeStep > 0 && activeStep < 4"
                                                        icon-pack="fas"
                                                        class="button is-info is-pulled-right"
                                                        :disabled="previous.disabled"
                                                        @click.prevent="previous.action"
                                                        style="margin-right: 30px;">
                                                    Back
                                                </b-button>
                                            </section>
                                        </template>
                                    </b-steps>

                                </section>
                            </template>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </layout-basic>
</template>

<script>
import StepOne from '@/components/reorder/StepOne'
import StepTwo from '@/components/reorder/StepTwo'
import StepFour from '@/components/reorder/StepFour'
import Success from '@/components/reorder/Success'
import LayoutBasic from '@/layouts/LayoutBasic'
import Cloudprinter from '@/services/CloudprinterService'
import NotificationService from '@/services/NotificationService'
import store from '@/store'
import BField from 'buefy/src/components/field/Field'
import AddressMixin from '@/mixins/AddressMixin'

export default {
  name: 'Products',
  components: {
    Success,
    BField,
    LayoutBasic,
    StepOne,
    StepTwo,
    StepFour
  },
  data () {
    return {
      activeStep: 0,
      isAnimated: true,
      hasNavigation: true,
      customNavigation: true,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      isStepsClickable: false,
      reorderData: {},
      cpCountries: [],
      cpProductInfo: {},
      quoteError: null
    }
  },
  mixins: [AddressMixin],
  created () {
    this.reorderData = this.$store.getters['cpReorder/allData']

    this.$validator.extend('zip_required', {
      getMessage: field => 'The zip field is required',
      validate: (value, [country]) => {
        if (value) {
          return true
        }

        return !this.zipIsRequired(country)
      }
    })
  },

  methods: {
    generateRandomString: function () {
      return new Date().getTime()
    },

    formSubmit: function (event) {
      event.preventDefault()

      if (this.activeStep === 0) {
        this.$validator.validate('general.*').then((result) => {
          if (result) {
            this.activeStep++
          }
        })
      }

      if (this.activeStep === 1) {
        this.$validator.validate('shipping_address_form.*').then((result) => {
          if (result) {
            this.activeStep++
          }
        })
      }

      if (this.activeStep === 2) {
        this.$validator.validate('shipping_method_form.*').then((result) => {
          if (result && !this.quoteError) {
            this.$store.dispatch('loader/show')
            this.orderPost()
              .then(() => {
                this.activeStep = 3
              })
              .catch(error => {
                NotificationService.warning('Something went wrong with order creation. ' + error.response.data.error.info)
              })
              .finally(() => {
                this.$store.dispatch('loader/hide')
              })
          }
        })
      }
    },

    orderPost: function () {
      const orderItems = this.$store.getters['cpReorder/orderItemsForOrder']
      const shippingAddress = this.$store.getters['cpReorder/shippingAddress']
      const orderReference = this.reorderData.originOrder.reference + '-reorder-' + new Date().getTime()

      let orderData = {
        'reference': orderReference,
        'mode': this.reorderData.mode,
        'email': store.getters['cpAuth/currentUser'].user.email,
        'addresses': [shippingAddress],
        'items': orderItems
      }

      return Cloudprinter.orderCreate(orderData)
    }

  }
}
</script>
